export default "__VITE_ASSET__1927e559__"